import React, { Suspense } from 'react';

const PartnerDetails = React.lazy(() => import('./partnerinformation/PartnerDetails'));
const VenueDetails = React.lazy(() => import('./VenueInformation/VenueDetails'));
const ProductDetails = React.lazy(() => import('./ProductInformation/ProductDetails'));
const EventDetails = React.lazy(() => import('./Eventinformation/EventDetails'));
const TempleInformation = React.lazy(() => import('./TempleInformation/TempleInformation'));
const Contract = React.lazy(() => import('./Contract'));
const RequiredDocument = React.lazy(() => import('./RequiredDocument'));
const EventRegistrationDetails = React.lazy(() => import('./EventRegistrationDetails/EventRegistrationDetails'));
const OrganizationDetails = React.lazy(() => import('./OrganizationDetails/OrganizationDetails'));

const TabContent = ({ activeTab, formData, setFormData, moveToNextTab }) => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      {(() => {
        switch (activeTab) {
          case 0:
            return <PartnerDetails formData={formData} setFormData={setFormData} moveToNextTab={moveToNextTab} />;
          case 1:
            return <VenueDetails formData={formData} setFormData={setFormData} moveToNextTab={moveToNextTab} />;
          case 2:
            return <ProductDetails formData={formData} setFormData={setFormData} moveToNextTab={moveToNextTab} />;
          case 3:
            return <EventDetails formData={formData} setFormData={setFormData} moveToNextTab={moveToNextTab} />;
          case 4:
            return <TempleInformation formData={formData} setFormData={setFormData} moveToNextTab={moveToNextTab} />;
          case 5:
            return <EventRegistrationDetails formData={formData} setFormData={setFormData} moveToNextTab={moveToNextTab} />;
          case 6:
            return <OrganizationDetails formData={formData} setFormData={setFormData} moveToNextTab={moveToNextTab} />;
          case 7:
            return <Contract moveToNextTab={moveToNextTab} />;
          case 8:
            return <RequiredDocument moveToNextTab={moveToNextTab} />;
          default:
            return null;
        }
      })()}
    </Suspense>
  );
};

export default TabContent;
